import { type MutationError, trpc } from '@/shared/api';

/** 기본 정보로 DRAFT 상품 생성 — 성공 시 생성된 상품을 돌려준다. */
export const useCreateProduct = () => {
  const mutation = trpc.productManagement.products.create.useMutation();

  const error: MutationError | null = mutation.error;

  return {
    createProduct: mutation.mutateAsync,
    isPending: mutation.isPending,
    error,
  };
};
